export const dateFormatStringWithOffset = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
export const dateFormatStringWithoutOffset = "yyyy-MM-dd'T'HH:mm:ss";
